export enum PlanAndExecuteNodes {
  planner = 'planner',
  executor = 'executor',
  replanner = 'replanner',
  solver = 'solver'
}
